import { gql } from '@apollo/client';
import { QUOTE_FIELDS_FRAGMENT } from './fragments/quoteFragment';

export const GET_QUOTE_BY_VO_ID = gql`
  query Quote($vendorOpportunityId: ID!) {
    vendorOpportunity(id: $vendorOpportunityId) {
      quote {
        ...QuoteFields
      }
    }
  }
  ${QUOTE_FIELDS_FRAGMENT}
`;
